export enum StatusHeader {
  notConnect = 'notConnect',
  waitConnect = 'waitConnect',
  connected = 'connected',
}
